import { useState } from "react";

import ContactMailIcon from "@mui/icons-material/ContactMail";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { AppBar, useStore } from "react-admin";
import { CustomNavigation } from "./CustomNavigation";
import { CustomSearchBar } from "./CustomSearchBar";
import { CustomUserMenu } from "./CustomUserMenu";
import { useCurrentUser } from "frontend/src/utils/hooks";
import { Tooltip } from "@mui/material";
import { NotificationBell } from "frontend/src/components/NotificationBell";
import { useRangerChatStore } from "frontend/src/components/RangerChat/chatStore";

export const CustomAppBar = () => {
  // const { useDarkTheme, setUseDarkTheme } = useContext(DisplayThemeContext);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const [showChat, setShowChat] = useStore("showChat", false);
  const openConversation = useRangerChatStore(s => s.openConversation);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const currentUser = useCurrentUser();

  const open = Boolean(anchorEl);
  const ContactSupportId = open ? "contact-support" : undefined;

  return (
    <AppBar userMenu={<CustomUserMenu />}>
      <div style={{ width: "100%" }}>
        <Toolbar style={{ minHeight: "48px" }}>
          <Typography
            variant="h6"
            color="inherit"
            sx={{
              "& a, & a:link, & a:visited, & a:hover": {
                color: "white",
                fontWeight: "bold",
                fontStyle: "normal",
                textDecoration: "none",
              },
            }}
            id="logo"
          >
            <a href="/">S I R I U S</a>
          </Typography>
          <span style={{ width: "24px" }} />
          <Typography
            sx={{
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
            variant="h6"
            color="inherit"
            id="react-admin-title"
          />
          <span style={{ flex: 1 }} />
          <CustomSearchBar />
          <span style={{ flex: 1 }} />
          <IconButton
            aria-describedby={ContactSupportId}
            arial-label="Contact External Support"
            title="Contact External Support"
            sx={{ color: "white" }}
            onClick={handleClick}
            size="large"
            color="inherit"
          >
            <ContactMailIcon />
          </IconButton>
          <Popover
            id={ContactSupportId}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <div style={{ margin: "1em" }}>
              <strong>Contact Support</strong>
              <p>
                Email:{" "}
                <a href="mailto:portal@therockcreekgroup.com">
                  portal@therockcreekgroup.com
                </a>
              </p>
            </div>
          </Popover>
          <NotificationBell
            sx={{ color: "white" }}
            // Only conversations: data-collection hosts the chat drawer but has
            // no guidelines, investment or notes screen, so rows for those stay
            // informational here rather than offering a link that does nothing.
            navigableSubjects={["CONVERSATION"]}
            onNavigate={({ subjectId }) => {
              openConversation(subjectId);
              setShowChat(true);
            }}
          />
          {currentUser.flags.isSubscriptionUser && (
            <Tooltip title="Sirius AI Chat" arrow>
              <IconButton
                aria-label="Toggle Chat"
                sx={{ color: "white", ml: 1, position: "relative" }}
                onClick={() => setShowChat(!showChat)}
                size="large"
                color="inherit"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  width="24"
                  style={{ display: "block" }}
                  fill="currentColor"
                >
                  <path d="M4 4h16v12H5.17L4 17.17V4zm0-2c-1.1 0-2 .9-2 2v20l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4z" />
                </svg>
              </IconButton>
            </Tooltip>
          )}
        </Toolbar>
        <CustomNavigation />
      </div>

      {/* Disabled until we support toggle for antd. 
        https://github.com/ant-design/ant-design-dark-theme/issues/8
      {useDarkTheme ? (
        <IconButton
          arial-label="Display Light Theme"
          title="Display Light Theme"
          className={classes.displayTheme}
          onClick={() => setUseDarkTheme(false)}
        >
          <LightIcon />
        </IconButton>
      ) : (
        <IconButton
          arial-label="Display Dark Theme"
          title="Display Dark Theme"
          className={classes.displayTheme}
          onClick={() => setUseDarkTheme(true)}
        >
          <DarkIcon />
        </IconButton>
      )} */}
    </AppBar>
  );
};
